import React from "react";
import Invoices from "./Invoices";

const ExpenseInvoices: React.FC = () => {
  return <Invoices type="expense" />;
};

export default ExpenseInvoices;
